<div class="authorize-net-confirmation p-4">
  <h2 class="mb-4">{{ 'authorize_net_confirm_title' | translate }}</h2>

  <!-- Initializing -->
  @if (initializing()) {
    <div class="text-center py-5">
      <c-spinner color="primary"></c-spinner>
      <p class="mt-3">{{ 'authorize_net_initializing' | translate }}</p>
    </div>
  }

  <!-- Init error -->
  @if (!initializing() && errorMessage() && !ready()) {
    <c-alert color="danger" class="mb-4">
      <h4 class="alert-heading">{{ 'authorize_net_error_title' | translate }}</h4>
      <p>{{ errorMessage().startsWith('authorize_net_') ? (errorMessage() | translate) : errorMessage() }}</p>
      <hr />
      <div class="d-flex gap-2">
        <button cButton color="danger" size="sm" (click)="retry()">
          {{ 'authorize_net_retry' | translate }}
        </button>
        <button cButton color="secondary" size="sm" (click)="goBack()">
          {{ 'authorize_net_back' | translate }}
        </button>
      </div>
    </c-alert>
  }

  <!-- Payment form -->
  @if (!initializing() && ready()) {
    <div class="payment-form">
      <!-- Order Summary -->
      <c-card class="mb-4 shadow-sm">
        <c-card-header>
          <strong>{{ 'authorize_net_order_summary' | translate }}</strong>
        </c-card-header>
        <c-card-body>
          <div class="d-flex justify-content-between mb-2">
            <span>{{ 'authorize_net_order_id' | translate }}</span>
            <strong>#{{ orderId }}</strong>
          </div>
          <div class="d-flex justify-content-between mb-2">
            <span>{{ 'authorize_net_subtotal' | translate }}</span>
            <span>{{ totalPrice | currencyAmount: currency }}</span>
          </div>
          @if (paymentCosts > 0) {
            <div class="d-flex justify-content-between mb-2 text-body-secondary">
              <span>{{ 'authorize_net_processing_fee' | translate }}</span>
              <span>{{ paymentCosts | currencyAmount: currency }}</span>
            </div>
          }
          <hr class="my-2" />
          <div class="d-flex justify-content-between mb-3">
            <strong>{{ 'authorize_net_total_amount' | translate }}</strong>
            <strong class="text-primary fs-4">
              {{ totalWithCosts | currencyAmount: currency }}
            </strong>
          </div>
          <div class="d-flex justify-content-between text-body-secondary small">
            <span>{{ 'authorize_net_mode' | translate }}</span>
            <c-badge [color]="mode() === 'live' ? 'success' : 'warning'">
              {{ mode() === 'live' ? ('authorize_net_mode_live' | translate) : ('authorize_net_mode_test' | translate) }}
            </c-badge>
          </div>
        </c-card-body>
      </c-card>

      <!-- Card Information -->
      <c-card class="mb-4 shadow-sm">
        <c-card-header>
          <strong>{{ 'authorize_net_card_information' | translate }}</strong>
        </c-card-header>
        <c-card-body>
          <div class="mb-3">
            <label class="form-label">{{ 'authorize_net_card_number' | translate }}</label>
            <input
              type="text"
              class="form-control"
              inputmode="numeric"
              autocomplete="cc-number"
              placeholder="1234 5678 9012 3456"
              [(ngModel)]="cardNumber"
              [disabled]="processing()"
            />
          </div>
          <div class="row g-3">
            <div class="col-6">
              <label class="form-label">{{ 'authorize_net_expiry' | translate }}</label>
              <input
                type="text"
                class="form-control"
                inputmode="numeric"
                autocomplete="cc-exp"
                placeholder="MM/YY"
                [(ngModel)]="expiry"
                [disabled]="processing()"
              />
            </div>
            <div class="col-6">
              <label class="form-label">{{ 'authorize_net_cvc' | translate }}</label>
              <input
                type="text"
                class="form-control"
                inputmode="numeric"
                autocomplete="cc-csc"
                placeholder="123"
                [(ngModel)]="cvc"
                [disabled]="processing()"
              />
            </div>
          </div>
          <div class="row g-3 mt-0">
            <div class="col-8">
              <label class="form-label">{{ 'authorize_net_cardholder' | translate }}</label>
              <input
                type="text"
                class="form-control"
                autocomplete="cc-name"
                [(ngModel)]="cardholder"
                [disabled]="processing()"
              />
            </div>
            <div class="col-4">
              <label class="form-label">{{ 'authorize_net_zip' | translate }}</label>
              <input
                type="text"
                class="form-control"
                inputmode="numeric"
                autocomplete="postal-code"
                [(ngModel)]="zip"
                [disabled]="processing()"
              />
            </div>
          </div>
        </c-card-body>
      </c-card>

      <!-- Error -->
      @if (errorMessage()) {
        <c-alert color="danger" class="mb-4">
          {{ errorMessage().startsWith('authorize_net_') ? (errorMessage() | translate) : errorMessage() }}
        </c-alert>
      }

      <!-- Processing overlay -->
      @if (processing()) {
        <div class="text-center py-3">
          <c-spinner size="sm" class="me-2"></c-spinner>
          {{ 'authorize_net_processing' | translate }}
        </div>
      }

      <!-- Actions -->
      <div class="d-flex gap-3">
        <button
          cButton
          color="secondary"
          size="lg"
          (click)="goBack()"
          [disabled]="processing()"
        >
          <svg cIcon name="cilArrowLeft" class="me-2"></svg>
          {{ 'authorize_net_back' | translate }}
        </button>
        <button
          cButton
          color="primary"
          size="lg"
          class="flex-grow-1"
          (click)="pay()"
          [disabled]="!canPay()"
        >
          {{ 'authorize_net_pay_now' | translate }}
        </button>
      </div>

      <!-- Security Note -->
      <div class="text-center mt-4 text-body-secondary small">
        <svg cIcon name="cilLockLocked" class="me-1"></svg>
        {{ 'authorize_net_secured_by' | translate }}
      </div>
    </div>
  }
</div>
